module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_4.cfa0ae91.jpg";